import { WhatsappLogo } from '@phosphor-icons/react';

export const WHATSAPP_URL =
  'https://wa.me/966538124880?text=' +
  encodeURIComponent('مرحبًا، أرغب بالاستفسار عن خدمات Child Horizons.');

const FloatingWhatsApp = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="تواصل عبر واتساب مع Child Horizons | آفاق الطفولة"
    title="Child Horizons | آفاق الطفولة"
    data-testid="floating-whatsapp"
    className="fixed bottom-5 left-5 sm:bottom-6 sm:left-6 z-40 w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#25D366] hover:bg-[#1DA851] shadow-lg shadow-[#25D366]/30 flex items-center justify-center transition-transform hover:scale-110 active:scale-95"
  >
    <WhatsappLogo size={24} weight="fill" className="text-white sm:hidden" />
    <WhatsappLogo size={28} weight="fill" className="text-white hidden sm:block" />
  </a>
);

export default FloatingWhatsApp;
